import { mapReplacementOptions } from "@/services/device-options/device-options.mapper";
import type { DeviceOptions } from "@/services/device-options/device-options.types";
import type { DeviceOptionsService } from "@/services/device-options/device-options-service";
import { resolveScenario } from "./scenarios";

export const SCENARIO_QUERY_PARAM = "scenario";

const wait = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

const activeScenarioId = (): string =>
  new URLSearchParams(window.location.search).get(SCENARIO_QUERY_PARAM) ?? "";

export class MockDeviceOptionsService implements DeviceOptionsService {
  public async getOptions(_params: { assetId: string; category: string }): Promise<DeviceOptions> {
    const scenario = resolveScenario(activeScenarioId());
    await wait(scenario.latencyMs);
    if (scenario.shouldFail) {
      throw new Error(`Simulated device-options load failure (scenario: ${scenario.id})`);
    }
    return mapReplacementOptions(scenario.wire);
  }
}
